
const util = {}
util.checkPhone = function (num) {
  var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/
  if (!myreg.test(num)) {
    console.log('手机号格式不正确')
    return false
  } else {
    console.log('手机号格式正确')
    return true
  }
}

/**
 * @description:
 * @param {
 * number验证数字
 * numLength验证数字的长度
 * }
 * @return {*}
 */
util.checkSearchRule = function (number, numLength = 16) {
  if (number.length > numLength) {
    number = number.slice(0, numLength)
  }
  if (number < 0) {
    number = Math.abs(number)
  }
  return number
}

/**
 * @description: 安卓手机键盘手机时，让input失去焦点
 * @param {*}
 * @return {*}
 */

util.inputAutoBlur = function () {
  const el = document.documentElement || document.body
  const originHeight = el.clientHeight
  window.addEventListener(
    'resize',
    () => {
      const resizeHeight = el.clientHeight
      if (resizeHeight < originHeight) {
        console.log('键盘弹起')
      } else {
        console.log('键盘收起')
        const likeArray = document.querySelectorAll('input')
        Array.from(likeArray, input => input.blur())
      }
    },
    false
  )
}
/**
 * @description: 排班专用开始时间减结束时间，转换成时间
 * @param {*}
 * @return {*}
 */
util.scNumToTime = function (num) {
  num = num.split('.')
  if (num.length > 1 && num[1] == '6') {
    num = Number(num[0]) + 1
  }
  if (num.length > 1 && num[1] == '4') {
    num = Number(num[0])
  }
  if (num.length > 1 && num[1] != '6' && num[1] != '4') {
    num = num[0] + '.5'
  }

  return num
}
// date转年月日
util.dateToString = function (d, sp) {
  sp = sp || '-'
  var year = d.getFullYear()
  var month = d.getMonth() + 1
  var date = d.getDate()
  var hour = d.getHours()
  var min = d.getMinutes()
  var sec = d.getSeconds()
  return year + sp + this.fixZero(month) + sp + this.fixZero(date)
}
//date转时间戳
util.dateToTime = function (dateStr) {
  if (!dateStr) {
    return ''
  }
  let newDataStr = dateStr.replace(/\.|\-/g, '/')
  let date = new Date(newDataStr)
  let timestamp = date.getTime()
  return timestamp
}

//date转时间戳
util.date2Time = function (dateStr) {
  if (!dateStr) {
    return ''
  }

  let date = new Date(dateStr)
  let timestamp = date.getTime()
  return timestamp
}
//date补零
util.fixZero = function (n) {
  n = n + ''
  return n.length == 1 ? '0' + n : n
}
// 判断微信环境
util.is_weixn = function () {
  var ua = navigator.userAgent.toLowerCase()
  if (ua.match(/MicroMessenger/i) == 'micromessenger') {
    return true
  } else {
    return false
  }
}
// 获取当前年月日
util.getNowDate = function () {
  var nowDate = new Date()
  var year = nowDate.getFullYear()
  var month = nowDate.getMonth() + 1 < 10 ? '0' + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1
  var day = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
  return year + '-' + month + '-' + day
}

// 获取当前年月
util.getNowMonth = function (sp = '-') {
  var nowDate = new Date()
  var year = nowDate.getFullYear()
  var month = nowDate.getMonth() + 1 < 10 ? '0' + (nowDate.getMonth() + 1) : nowDate.getMonth() + 1
  var day = nowDate.getDate() < 10 ? '0' + nowDate.getDate() : nowDate.getDate()
  return year + sp + month
}
//根据当前天数，获取加减几天日期
util.getNowFormatDate = function (AddDayCount) {
  var dd = new Date()
  dd.setDate(dd.getDate() + AddDayCount)
  var year = dd.getFullYear()
  var mon = dd.getMonth() + 1
  var day = dd.getDate()
  if (mon >= 0 && mon <= 9) {
    mon = '0' + mon
  }
  if (day >= 0 && day <= 9) {
    day = '0' + day
  }
  return year + '-' + mon + '-' + day
}
util.getNowFormatDate2 = function (AddDayCount, date) {
  var dd = new Date(date)
  dd.setDate(dd.getDate() + AddDayCount)
  var year = dd.getFullYear()
  var mon = dd.getMonth() + 1
  var day = dd.getDate()
  if (mon >= 0 && mon <= 9) {
    mon = '0' + mon
  }
  if (day >= 0 && day <= 9) {
    day = '0' + day
  }
  return year + '-' + mon + '-' + day
}
// 倒计时
util.getRTime = function (endTime) {
  var str = endTime.split('-')
  var str2 = str.join('/')

  var EndTime = new Date(str2)
  var NowTime = new Date()
  var t = EndTime.getTime() - NowTime.getTime()

  var d = Math.floor(t / 1000 / 60 / 60 / 24)
  var h = Math.floor((t / 1000 / 60 / 60) % 24)
  var m = Math.floor((t / 1000 / 60) % 60)
  var s = Math.floor((t / 1000) % 60)

  if (h >= 0 && h <= 9) {
    h = '0' + h
  }
  if (m >= 0 && m <= 9) {
    m = '0' + m
  }
  return [h, m]
}
// 获取本周周一
util.getMonday = function (date = new Date()) {
  var day = date.getDay()
  var deltaDay
  if (day == 0) {
    deltaDay = 6
  } else {
    deltaDay = day - 1
  }
  var monday = new Date(date.getTime() - deltaDay * 24 * 60 * 60 * 1000)
  monday.setHours(0)
  monday.setMinutes(0)
  monday.setSeconds(0)

  return this.dateToString(monday, '-') //返回本周的周一的0时0分0秒
}
// 获取周日
util.getSunday = function (date = new Date()) {
  var nowTime = date.getTime()
  var day = date.getDay()
  if (day == 0) {
    day = 7
  }
  var SundayTime = new Date(nowTime + (7 - day) * 24 * 60 * 60 * 1000) //显示周日
  SundayTime.setHours(0)
  SundayTime.setMinutes(0)
  SundayTime.setSeconds(0)
  console.log(SundayTime)
  return this.dateToString(SundayTime, '-')
}
// 根据date获取本月第一天
util.getFirstDayOfMonth = function (date = new Date()) {
  date.setDate(1)
  return this.dateToString(date, '-')
}
// 根据date获取本月最后一天
util.getLastDayOfMonth = function (date, type = '-') {
  var date1 = date.split(type)
  var month = Number(date1[1])
  var monthEndDate = new Date(date1[0], month, 0)
  // var timeEnd = Date.parse(monthEndDate) / 1000;//s
  monthEndDate.setHours(0)
  monthEndDate.setMinutes(0)
  monthEndDate.setSeconds(0)
  return this.dateToString(monthEndDate, '-')
}

// 获取周一周日
util.getTime = function (n) {
  var now = new Date()
  var year = now.getFullYear()
  //因为月份是从0开始的,所以获取这个月的月份数要加1才行
  var month = now.getMonth() + 1
  var date = now.getDate()
  var day = now.getDay()
  console.log(day)
  //判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
  // if (day !== 0) {
  n = n + (day - 1)
  // } else {
  // n = n + day;
  // }
  if (day) {
    //这个判断是为了解决跨年的问题
    if (month > 1) {
      month = month
    }
    //这个判断是为了解决跨年的问题,月份是从0开始的
    else {
      year = year - 1
      month = 12
    }
  }
  now.setDate(now.getDate() - n)
  year = now.getFullYear()
  month = now.getMonth() + 1
  date = now.getDate()
  // console.log(n);
  var s = year + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date)
  return s
}

// 根据date获取星期几
util.getWeekByDate = function (date) {
  return new Date(date).getDay()
}

util.isdate = function (date, type = '-') {
  var intYear = date.split(type)[0]
  var intMonth = date.split(type)[1]
  var intDay = date.split(type)[2]
  if (isNaN(intYear) || isNaN(intMonth) || isNaN(intDay)) return false
  if (intMonth > 12 || intMonth < 1) return false
  if (intDay < 1 || intDay > 31) return false
  if ((intMonth == 4 || intMonth == 6 || intMonth == 9 || intMonth == 11) && intDay > 30) return false
  if (intMonth == 2) {
    if (intDay > 29) return false
    if (((intYear % 100 == 0 && intYear % 400 != 0) || intYear % 4 != 0) && intDay > 28) return false
  }
  return true
}

// 原生ajax
util.ajax_method = function (url, data, method = 'get', success) {
  var ajax = new XMLHttpRequest()
  if (method == 'get') {
    if (data) {
      url += '?'
      url += data
    } else {
    }
    ajax.open(method, url)
    ajax.send()
  } else {
    ajax.open(method, url)
    // ajax.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
    if (data) {
      ajax.send(data)
    } else {
      ajax.send()
    }
  }
  ajax.onreadystatechange = function () {
    // 在事件中 获取数据 并修改界面显示
    if (ajax.readyState == 4 && ajax.status == 200) {
      success(ajax.responseText)
    }
  }
}
// 加法
util.accAdd = function (arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  //动态控制精度长度
  n = r1 >= r2 ? r1 : r2
  return ((arg1 * m + arg2 * m) / m).toFixed(n)
}

// 减法
util.accSub = function (arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2)) //last modify by deeka //动态控制精度长度
  n = r1 >= r2 ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}
// 乘法
util.accMul = function (arg1, arg2) {
  var m = 0,
    s1 = arg1.toString(),
    s2 = arg2.toString()
  try {
    m += s1.split('.')[1].length
  } catch (e) { }
  try {
    m += s2.split('.')[1].length
  } catch (e) { }
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / Math.pow(10, m)
}
// 除法
util.accDiv = function (arg1, arg2) {
  var r1, r2, m, n
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  m = Math.pow(10, Math.max(r1, r2))
  //动态控制精度长度
  n = r1 >= r2 ? r1 : r2
  return ((arg1 * m + arg2 * m) / m).toFixed(n)
}

// SHA1  
function add (x, y) {
  return ((x & 0x7FFFFFFF) + (y & 0x7FFFFFFF)) ^ (x & 0x80000000) ^ (y & 0x80000000)
}

function SHA1hex (num) {
  var sHEXChars = "0123456789abcdef"
  var str = ""
  for (var j = 7; j >= 0; j--)
    str += sHEXChars.charAt((num >> (j * 4)) & 0x0F)
  return str
}

function AlignSHA1 (sIn) {
  var nblk = ((sIn.length + 8) >> 6) + 1,
    blks = new Array(nblk * 16)
  for (var i = 0; i < nblk * 16; i++) blks[i] = 0
  for (i = 0; i < sIn.length; i++)
    blks[i >> 2] |= sIn.charCodeAt(i) << (24 - (i & 3) * 8)
  blks[i >> 2] |= 0x80 << (24 - (i & 3) * 8)
  blks[nblk * 16 - 1] = sIn.length * 8
  return blks
}

function rol (num, cnt) {
  return (num << cnt) | (num >>> (32 - cnt))
}

function ft (t, b, c, d) {
  if (t < 20) return (b & c) | ((~b) & d)
  if (t < 40) return b ^ c ^ d
  if (t < 60) return (b & c) | (b & d) | (c & d)
  return b ^ c ^ d
}

function kt (t) {
  return (t < 20) ? 1518500249 : (t < 40) ? 1859775393 :
    (t < 60) ? -1894007588 : -899497514
}

util.SHA1 = function (sIn) {
  var x = AlignSHA1(sIn)
  var w = new Array(80)
  var a = 1732584193
  var b = -271733879
  var c = -1732584194
  var d = 271733878
  var e = -1009589776
  for (var i = 0; i < x.length; i += 16) {
    var olda = a
    var oldb = b
    var oldc = c
    var oldd = d
    var olde = e
    for (var j = 0; j < 80; j++) {
      if (j < 16) w[j] = x[i + j]
      else w[j] = rol(w[j - 3] ^ w[j - 8] ^ w[j - 14] ^ w[j - 16], 1)
      let t = add(add(rol(a, 5), ft(j, b, c, d)), add(add(e, w[j]), kt(j)))
      e = d
      d = c
      c = rol(b, 30)
      b = a
      a = t
    }
    a = add(a, olda)
    b = add(b, oldb)
    c = add(c, oldc)
    d = add(d, oldd)
    e = add(e, olde)
  }
  let SHA1Value = SHA1hex(a) + SHA1hex(b) + SHA1hex(c) + SHA1hex(d) + SHA1hex(e)
  // return SHA1Value.toUpperCase();  
  return SHA1Value
}

// url参数解析
util.getUrlkey = function (url) {
  var params = {}
  var urls = url.split("?")
  var arr = urls[1].split("&")
  for (var i = 0, l = arr.length; i < l; i++) {
    var a = arr[i].split("=")
    params[a[0]] = a[1]
  }
  return params
}

util.gioFunc = (data) => {
  let employeeData = JSON.parse(localStorage.getItem('workbench_employee'))
  let brand_code = localStorage.getItem('workbench_app_brand')
  employeeData.brand_code = brand_code
  const mergedObj = { ...employeeData, ...data }
  gio('workbench_h5_pageInfo_view.set', mergedObj)
}

export { util }